export default __webpack_public_path__ + "assets/images/aistudio/empty_state/e3385a7cd81765f3c7a4f976c6f37b71.png";